import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { BRAND } from '../lib/brand';
import { Building2, MapPin, Phone, Mail, FileText } from 'lucide-react';

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-[hsl(var(--background))]">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="impressum-page">
        <h1 className="font-heading font-semibold text-3xl sm:text-4xl text-[hsl(var(--primary))]">Impressum</h1>
        <p className="text-sm text-slate-600 mt-1">Offenlegung gemäß § 5 ECG, § 14 UGB und § 25 MedienG (Österreich).</p>

        <Card className="mt-6 rounded-2xl border-slate-200">
          <CardContent className="p-6 space-y-5 text-sm text-slate-800 leading-relaxed">
            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900 flex items-center gap-2"><Building2 className="h-4 w-4 text-[hsl(var(--primary))]" /> Diensteanbieter / Medieninhaber</h2>
              <div className="mt-2">
                <div><strong>Rezart Gashi</strong></div>
                <div>Einzelunternehmer</div>
                <div className="mt-1">Unternehmensgegenstand: Digitale Schadensabwicklung &amp; Concierge-Dienstleistungen rund um Verkehrsunfälle</div>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900 flex items-center gap-2"><MapPin className="h-4 w-4 text-[hsl(var(--primary))]" /> Anschrift</h2>
              <div className="mt-2">
                Draschestraße 75<br />
                1230 Wien<br />
                Österreich
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900 flex items-center gap-2"><Phone className="h-4 w-4 text-[hsl(var(--primary))]" /> Kontakt</h2>
              <div className="mt-2 space-y-1">
                <div>Telefon: <a className="text-[hsl(var(--primary))] hover:underline" href={`tel:${BRAND.phone}`}>{BRAND.phoneDisplay}</a></div>
                <div>E-Mail: <a className="text-[hsl(var(--primary))] hover:underline" href="mailto:info@unfallheld.com">info@unfallheld.com</a></div>
                <div className="text-xs text-slate-500">Bevorzugte Kontaktaufnahme via Telefon oder WhatsApp für dringende Fälle.</div>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900 flex items-center gap-2"><FileText className="h-4 w-4 text-[hsl(var(--primary))]" /> Unternehmensdaten</h2>
              <div className="mt-2 space-y-1">
                <div>UID-Nummer: <strong>ATU76441646</strong></div>
                <div>Rechtsform: Einzelunternehmer</div>
                <div>Gerichtsstand: Wien</div>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">Aufsichtsbehörde / Gewerbebehörde</h2>
              <p className="mt-2">Magistratisches Bezirksamt Wien (zuständige Gewerbebehörde am Standort).</p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">Anwendbares Recht</h2>
              <p className="mt-2">Es gilt österreichisches Recht. Gerichtsstand ist, soweit gesetzlich zulässig, Wien.</p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">Online-Streitbeilegung</h2>
              <p className="mt-2">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a className="text-[hsl(var(--primary))] hover:underline" href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">ec.europa.eu/consumers/odr</a>.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">Haftungsausschluss</h2>
              <p className="mt-2">
                Trotz sorgfältiger inhaltlicher Kontrolle wird keine Haftung für die Inhalte externer Links übernommen.
                Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich. Die durch UnfallHeld
                erstellten KI-gestützten Schadens-Ersteinschätzungen sind <strong>unverbindlich</strong> und ersetzen kein
                offizielles Sachverständigengutachten.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">Urheberrecht</h2>
              <p className="mt-2">
                Alle Inhalte (Texte, Bilder, Logos, Grafiken) auf dieser Website sind urheberrechtlich geschützt.
                Eine Verwendung außerhalb des privaten Gebrauchs ist nur mit ausdrücklicher Zustimmung des Diensteanbieters zulässig.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-slate-900">Allgemeine Geschäftsbedingungen (AGB)</h2>
              <p className="mt-2">
                Detaillierte Allgemeine Geschäftsbedingungen werden auf Anfrage zur Verfügung gestellt bzw. dem Kunden im Rahmen
                der Beauftragung übermittelt. Bis dahin gilt: Es kommt ein Werk- oder Dienstleistungsverhältnis nach
                österreichischem Recht zustande. Honorare und Leistungsumfang werden vor Beauftragung transparent vereinbart.
              </p>
            </section>
          </CardContent>
        </Card>
      </main>
      <Footer />
    </div>
  );
}
